import React, { useContext } from "react";
import { VMContext } from "./vmContext";
import VersionManagementList from "./QueryList";
import QuerySetListEditDelete from "./QuerySetListEditDelete";
import QuerySetAdd from "./QuerySetAdd";
import QuerySetRelease from "./QuerySetRelease";
import Utils from "../../../Common/Utils";
import { Link } from "react-router-dom";

function VMManage(props) {
  const vmcontextdata = useContext(VMContext);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <h2>Version Manager</h2>
        <hr />

        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#Download"
              type="button"
              role="tab"
              aria-controls="Download"
              aria-selected="true"
            >
              <strong>Queries</strong>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="qset-tab"
              data-bs-toggle="tab"
              data-bs-target="#upload"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected="false"
            >
              <strong>Query Set</strong>
            </button>
          </li>
          {vmcontextdata.currentRealeasingSetId !== null && (
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="rset-tab"
                data-bs-toggle="tab"
                data-bs-target="#rset"
                type="button"
                role="tab"
                aria-controls="rset"
                aria-selected="false"
              >
                <strong>Set Deployment Info</strong>&nbsp;
                <Link
                  to="#"
                  type="button"
                  className="btn-close btn-sm"
                  aria-label="Close"
                  onClick={() => {
                    vmcontextdata.setCurrentRealeasingSetId(null);
                    Utils.click_button("qset-tab");
                  }}
                ></Link>
              </button>
            </li>
          )}
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="Download"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <VersionManagementList />
          </div>
          <div
            className="tab-pane fade"
            id="upload"
            role="tabpanel"
            aria-labelledby="qset-tab"
          >
            <div>
              <QuerySetAdd />
              <div className="row">&nbsp;</div>
              <QuerySetListEditDelete />
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="rset"
            role="tabpanel"
            aria-labelledby="rset-tab"
          >
            <div>
              <QuerySetRelease />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default VMManage;
